'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { getBlockStyle } from '@redteclab/storyblok-style-field-plugin'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokVideoType } from '../../storyblok'

const VIDEO_PROVIDER = '3q'
export const StoryblokVideo: FC<
  StoryblokComponentProps<StoryblokVideoType>
> = ({ blok }) => {
  const intl = useIntl()
  const { aspectRatio, id, style } = blok

  const { blockClassName, blockStyle } = getBlockStyle(style)

  return (
    // eslint-disable-next-line react/iframe-missing-sandbox -- trust 3Q Video and allow `allow-same-origin` & `allow-scripts` together
    <iframe
      {...storyblokEditable(blok)}
      allow="autoplay; picture-in-picture; encrypted-media; fullscreen"
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className={clsx(
        'w-full rounded-s',
        blockClassName,
        aspectRatio === '9:16' && 'aspect-[9/16]',
        aspectRatio === '1:1' && 'aspect-square',
        (aspectRatio === '16:9' || !aspectRatio) && 'aspect-video',
      )}
      sandbox="allow-presentation allow-same-origin allow-scripts"
      src={`https://playout.3qsdn.com/${id}`}
      style={blockStyle}
      title={intl.formatMessage(
        {
          id: 'general.iframe.videoTitle',
        },
        {
          provider: VIDEO_PROVIDER,
        },
      )}
    />
  )
}
